import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationsApiService } from 'src/app/services/api/applications-api.service';
import { ApplicationService } from 'src/app/services/application-service';
import { BasicInfoService } from 'src/app/services/basic-info.service';
import { reasonOptions } from 'src/configs/dropdown-options/options.se';
import { handleApiError } from 'src/app/utils/error';
import { Subscription, timer } from 'rxjs';
import { FlowService } from 'src/app/services/flow.service';
import { take } from 'rxjs/operators';
import { TrackingService } from 'src/app/services/tracking.service';

@Component({
  selector: 'app-purpose',
  templateUrl: './purpose.component.html',
  styleUrls: ['./purpose.component.scss'],
})
export class PurposeComponent implements OnInit, OnDestroy {
  applicationId!: number;
  purposeForm!: FormGroup;
  reasonOptions = reasonOptions;
  error!: string;
  subs: Array<Subscription> = [];
  requestPending = false;
  @Input() isSummary!: boolean;

  constructor(
    private basicInfoService: BasicInfoService,
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private applicationService: ApplicationService,
    private applicationsApiService: ApplicationsApiService,
    public flowService: FlowService,
    protected trackingService: TrackingService
  ) {
  }

  ngOnInit(): void {
    const initialReason =
      this.applicationService.reason || this.basicInfoService.reason;
    const initialReasonDescription = this.applicationService.reasonDescription;

    this.applicationId = this.applicationService.applicationId;

    this.purposeForm = this.formBuilder.group({
      reason: [initialReason],
      reasonDesc: [initialReasonDescription, { updateOn: 'blur' }],
    });

    this.subs.push(
      this.reason.valueChanges.subscribe((v) => {
        this.requestPending = true;
        this.applicationService.reason = v;
        this.applicationsApiService
          .updateApplication({ reason: v, applicationId: this.applicationId })
          .pipe(take(1))
          .subscribe(
            () => {
              this.error = '';
              this.trackFields('reason2');
            },
            (error: any) => handleApiError(error, this.translateService),
            () => this.requestPending = false
          );
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.map((sub) => sub.unsubscribe());
  }

  trackFields(field: string): void {
    this.trackingService.filledField(field);
  }

  reasonDescriptionUpdate(): void {
    this.requestPending = true;
    const description = this.reasonDesc.value;
    this.applicationService.reasonDescription = description;
    this.applicationsApiService
      .updateApplication({
        reasonDesc: description,
        applicationId: this.applicationId,
      })
      .pipe(take(1))
      .subscribe(
        () => {
          this.error = '';
          this.trackFields('reasonDesc');
        },
        (error: any) => handleApiError(error, this.translateService),
        () => this.requestPending = false
      );
  }

  handleBackButtonClick(): void {
    this.subs.push(timer(1000, 1000).subscribe(() => {
      if (!this.requestPending) {
        this.flowService.previousScreen();
      }
    }));
  }

  handleContinueButtonClick(): void {
    this.subs.push(timer(1000, 1000).subscribe(() => {
      if (!this.requestPending) {
        this.flowService.nextScreen();
      }
    }));
  }

  get form(): FormGroup {
    return this.purposeForm;
  }

  get reason(): FormControl {
    return this.form.get('reason') as FormControl;
  }

  get reasonDesc(): FormControl {
    return this.form.get('reasonDesc') as FormControl;
  }
}
